import { useEffect, useState } from 'react';
import { Link2, PlusCircle, EyeOff } from 'lucide-react';
import { toast } from 'sonner';
import { money, qty, errMsg } from './invApi';

const Row = ({ r, api, canSeeCosts, onDone }) => {
  const act = async (action, item_id) => {
    try { await api.post(`/reviews/${r.id}/resolve`, { action, item_id }); toast.success(action === 'ignore' ? 'Ligne ignorée' : 'Entrée au stock'); onDone(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const l = r.line;
  return (
    <div className="bg-slate-900 border border-slate-800 rounded-xl p-4 space-y-3" data-testid={`review-${r.id}`}>
      <div className="flex flex-wrap items-baseline gap-x-3">
        <p className="text-sm text-white">{l.description || l.part_number}</p>
        <p className="text-xs text-slate-500">{l.part_number} · Qté {qty(l.quantity)}{canSeeCosts ? ` · ${money(l.unit_cost)}` : ''} · {r.supplier_name}</p>
      </div>
      <p className="text-xs text-slate-400">{r.kind === 'maybe' ? 'Ressemble à une pièce connue :' : 'Pièce jamais vue : nouvelle pièce ?'}</p>
      <div className="flex flex-wrap gap-2">
        {r.candidates.map(c => (
          <button key={c.id} onClick={() => act('link', c.id)} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-sky-500/15 text-sky-300 text-xs hover:bg-sky-500/25" data-testid={`review-link-${r.id}-${c.id}`}>
            <Link2 size={12} /> Même pièce que {c.name} {c.part_number ? `(${c.part_number})` : ''}
          </button>
        ))}
        <button onClick={() => act('create')} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-emerald-500/15 text-emerald-300 text-xs hover:bg-emerald-500/25" data-testid={`review-create-${r.id}`}><PlusCircle size={12} /> Nouvelle pièce</button>
        <button onClick={() => act('ignore')} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-slate-400 text-xs hover:text-white" data-testid={`review-ignore-${r.id}`}><EyeOff size={12} /> Pas une pièce (frais…)</button>
      </div>
    </div>
  );
};

export const ReviewsTab = ({ api, canSeeCosts, onChange }) => {
  const [rows, setRows] = useState([]);
  const load = () => api.get('/reviews').then(setRows);
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const done = () => { load(); onChange?.(); };
  const createAll = async () => {
    for (const r of rows.filter(x => x.kind === 'new')) await api.post(`/reviews/${r.id}/resolve`, { action: 'create' }).catch(() => {});
    toast.success('Nouvelles pièces créées'); done();
  };
  if (!rows.length) return <p className="text-sm text-slate-500 py-8 text-center" data-testid="reviews-empty">Rien à confirmer. Les pièces reconnues entrent seules au stock.</p>;
  return (
    <div className="space-y-3" data-testid="inventory-reviews-tab">
      {rows.some(r => r.kind === 'new') && (
        <button onClick={createAll} className="text-xs text-emerald-300 hover:text-emerald-200" data-testid="reviews-create-all">Créer toutes les pièces jamais vues ({rows.filter(r => r.kind === 'new').length})</button>
      )}
      {rows.map(r => <Row key={r.id} r={r} api={api} canSeeCosts={canSeeCosts} onDone={done} />)}
    </div>
  );
};
